export default __webpack_public_path__ + "static/media/AviciiTheNights.dd47aacb.mp3";